export const validateInput = (fieldId, value) => {
  return value.length === 0 && fieldId !== "keyword" ? false : true;
};

export const calculateCanSend = validations => {
  return Object.keys(validations).every(
    validationKey => validations[validationKey] === true
  );
};
